import { render } from "./EventNotificationModal.vue?vue&type=template&id=d9b54694&scoped=true"
import script from "./EventNotificationModal.vue?vue&type=script&lang=js"
export * from "./EventNotificationModal.vue?vue&type=script&lang=js"

import "./EventNotificationModal.vue?vue&type=style&index=0&id=d9b54694&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d9b54694"]])

export default __exports__